import React, { MouseEvent } from 'react'
import './breadcrumb.css'
import { Link } from 'react-router-dom'
import { BreadcrumbPropsInterface } from '../../utils/constants/Interfaces.constants'

const Breadcrumb: React.FunctionComponent<BreadcrumbPropsInterface> = ({ routes, callbackFunc }) => {
    
    const handleClick = (ev: MouseEvent<HTMLAnchorElement>, route: string) => {
        if (route.length === 0) {
            ev.preventDefault()
            return
        }
        if (typeof callbackFunc === 'function') {
            callbackFunc()
        }
    }

  return (
    <div className='d-flex align-items-center mt-2 pt-1'>
        {
            routes.map((item, index) => (
                <div key={index}>
                    <Link
                        className={routes.length - 1 !== index ? 'no-text-decoration text-capitalize weight-400 breadcrumb-link' : 'no-text-decoration text-capitalize weight-400 breadcrumb-link breadcrumb-link-current'}
                        to={item.route}
                        onClick={(ev) => handleClick(ev, item.route)}
                    >
                        {item.routeLabel}
                    </Link>
                    {
                        routes.length - 1 !== index &&
                        <span className='mx-2 text-capitalize weight-400 breadcrumb-link'>{ '>' }</span>
                    }
                </div>
            ))
        }
    </div>
  )
}

export default Breadcrumb